// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"da2043ea","455":"d73d7ec4","977":"d52eb67f"}[chunkId] + ".chunk.js";
};